/* eslint-disable prettier/prettier */

import styled from 'styled-components'
import { Button } from '@gympass/yoga'
import getBreakpoint from '@client/utils/breakpoints'

import Image from '@components/Image'
import { Body2 } from '@components/Typography'
import { H1, H4 } from '@components/Text'

import { gympassHeader } from '@assets'

import {
  CircularProgress,
  DialogContent as MuiDialogContent,
} from '@material-ui/core'

export const HeaderStyled = styled.header`
  padding-top: 32px;
  background-color: #FF7A4E;

  @media (min-width: ${getBreakpoint('lg')}px) {
    background-image: url(${gympassHeader});
    background-size: auto 100%;
    background-position: 105%;
    background-repeat: no-repeat;
  }

  @media (min-width: ${getBreakpoint('xxl')}px) {
    background-position: 95%;
  }
`

export const GympassLogo = styled(Image)`
  width: 128px;
`

export const GympassStayHome = styled.img`
  max-width: 100%;
  margin-top: 40px;
`

export const HeaderTitle = styled(H1)`
  margin-top: 48px;
  color: #ffffff;
  font-weight: 400;
  line-height: 42px;
  letter-spacing: 0.5px;
  span {
    font-weight: 900;
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 60px;
    margin-bottom: 0;
    width: 100%;
    line-height: 56px;
  }
`

export const HeaderSubtitle = styled(H4)`
  color: #ffffff;
  margin-top: 16px;
  letter-spacing: 0.5px;
  line-height: 26px;
  font-weight: 400;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 16px;
  }
`

export const FormWrapper = styled.section`
  display: flex;
  flex-direction: column;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin-top: 32px;
  }
`

export const Form = styled.form`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-radius: 100px;
  background-color: transparent;
  box-sizing: border-box;
  margin-top: 32px;
  margin-bottom: 8px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 496px;
    background-color: #ffffff;
    padding: 8px;
    max-width: none;
    margin: 0;
  }
`

export const FormAction = styled.section`
  width: 100%;

  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 176px;
  }
`

export const Input = styled.input`
  border-radius: 100px;
  border: none;
  margin-bottom: 12px;
  padding: 0 24px;
  width: 100%;
  height: 64px;

  font-family: Lato;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin: 0;
    padding: 0 10px;
    flex-grow: 1;
    outline: none;
    width: 0;
    height: auto;
  }
`
export const RelativeContainer = styled.section`
  position: relative;
`

export const ErrorMessage = styled(Body2)`
  position: absolute;
  color: #ffffff;
  height: 24px;
  bottom: -25px;

  @media (min-width: ${getBreakpoint('xl')}px) {
    margin: 16px 18px 0;
    max-width: initial;
    bottom: -32px;
  }
`

export const FormButton = styled(Button)`
  display: flex;
  justify-content: space-around;
  align-items: center;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  height: 48px;
`

export const Progress = styled(CircularProgress)`
  &.MuiCircularProgress-colorPrimary {
    color: #ffffff;
  }
`
export const StyledReCaptcha = styled.div`
  margin-right: auto;
`

export const VideoButtonWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 48px;
  margin-bottom: 64px;
  cursor: pointer;

  p {
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 24px;
    color: #ffffff;
    margin: 0 0 0 16px;
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    justify-content: flex-start;
    margin-top: 40px;
    margin-bottom: 64px;
  }
`

export const DialogContent = styled(MuiDialogContent)`
  width: 296px;

  &.MuiDialogContent-root,
  &.MuiDialogContent-root:first-child {
    padding: 0;
  }

  @media (min-width: ${getBreakpoint('md')}px) {
    width: 599px;
  }

  @media (min-width: ${getBreakpoint('xl')}px) {
    width: 900px;
  }
`

export const VideoWrapper = styled.section`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;

  iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`